<template>
  <span
    class="time-switch"
    :class="{
      'd-flex align-items-center justify-content-center': mobileView,
      'text-center mr-0 my-2 d-inline-block': monthMobile,
      link: weekMobile,
    }"
    @click="weekMobile ? $emit('toMonthView') : ''"
  >
    <h4
      class="calendar-month d-inline-block"
      :class="{
        'order-2': mobileView,
        text: weekMobile,
      }"
    >
      {{ $t(`calendar.header.months.${activeMonth}`) }}
    </h4>
    <h4
      class="calendar-year h4 d-sm-inline-block"
      :class="{
        'd-none': monthMobile,
        'd-inline-block order-3 text': weekMobile,
      }"
    >
      {{ activeYear }}
    </h4>
    <Arrow
      @click.native="weekMobile ? '' : changeInterval(-1)"
      class="arrow arrow_left arrow_color_timeint"
      :class="{ 'order-1 no-bottom': mobileView, 'mx-0': monthMobile }"
    />
    <Arrow
      @click.native="changeInterval(1)"
      class="arrow arrow_right arrow_color_timeint"
      :class="{ 'order-3 no-bottom mx-0': monthMobile, 'd-none': weekMobile }"
    />
    <h6 v-if="selectedView === 'week' && !mobileView" class="time-switch__week">
      {{
        startDay.getDate() +
          ' ' +
          $t(`calendar.header.monthsInDate.${startDay.getMonth()}`)
      }}
      -
      {{
        endDay.getDate() +
          ' ' +
          $t(`calendar.header.monthsInDate.${endDay.getMonth()}`)
      }}
    </h6>
  </span>
</template>

<script>
import Arrow from './Arrow'

export default {
  props: {
    selectedView: String,
    startDay: Date,
    endDay: Date,
  },
  computed: {
    activeMonth() {
      if (this.selectedView === 'week') {
        return this.endDay.getMonth()
      } else {
        return new Date(
          this.startDay.getFullYear(),
          this.startDay.getMonth(),
          this.startDay.getDate() + 8
        ).getMonth()
      }
    },
    activeYear() {
      if (this.selectedView === 'week') {
        return this.endDay.getFullYear()
      } else {
        let date = new Date(
          this.startDay.getFullYear(),
          this.startDay.getMonth(),
          this.startDay.getDate() + 8
        )
        return date.getFullYear()
      }
    },
    mobileView() {
      return this.$mq === 'sm'
    },
    monthMobile() {
      return this.selectedView === 'month' && this.mobileView
    },
    weekMobile() {
      return this.selectedView === 'week' && this.mobileView
    },
  },
  methods: {
    changeInterval(direction) {
      if (this.selectedView === 'month') {
        this.changeMonth(direction)
      } else {
        this.changeWeek(direction)
      }
    },
    changeWeek(direction) {
      this.$emit(
        'changeDateStart',
        new Date(
          this.startDay.getFullYear(),
          this.startDay.getMonth(),
          this.startDay.getDate() + direction * 7
        )
      )
    },
    changeMonth(direction) {
      let date = new Date(
        this.startDay.getFullYear(),
        this.startDay.getMonth(),
        this.startDay.getDate() + 8
      )
      let dateOfNewMonth = new Date(
        date.getFullYear(),
        date.getMonth() + direction,
        1
      )
      this.$emit('changeDateStart', dateOfNewMonth)
    },
  },
  components: {
    Arrow,
  },
}
</script>

<style lang="scss">
.time-switch {
  letter-spacing: 0.08rem;
  position: relative;
  &__week {
    display: block;
    position: absolute;
    top: 2.26666rem;
    font-size: 0.8rem;
    font-weight: bold;
    letter-spacing: -0.00666rem;
    color: $title-color;
  }

  &.link {
    position: absolute;
    bottom: -30px;
    left: -8px;
    z-index: 10;

    & > * {
      color: $primary-color2;
    }
    & > svg {
      stroke: $primary-color2;
    }

    .text {
      width: auto;
      font-size: 12px;
      font-weight: normal;
      margin-bottom: 0;
      margin-top: 2px;
    }
  }
}
.calendar {
  &-month {
    font-weight: 700;
    margin-bottom: 0;
    width: 9rem;
  }
  &-year {
    margin: 0 0.33333rem;
  }
  &-sorting__date-week {
    position: absolute;
    width: 70%;
    top: 21px;
    left: 3px;
    z-index: 100;
  }
}
</style>
